import EventActionProto from '../event-action-proto';
import SessionLoader from "core/gd/data/session-loader";

export default class SessionDependencyNew extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            isBulkUpdate: sessionEvent.isBulkUpdate, // probably it should be true on import tasks otherwise currently there is no way to bulk add tasks
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false;

        // this.data format
        // {
        //     id           : 'ddT8l6',
        //     type         : 5,
        //     task1Id      : 'rI0UfA',
        //     task2Id      : '8OaanB',
        //     project1Id   : 'rI0UfA',
        //     project2Id   : '8OaanB',
        //     event1Id     : 'rI0UfA',
        //     event2Id     : '8OaanB'
        // }

        // console.log("SessionTaskNew process", this);

        const statuses = []
        if (this.data.task1)    statuses.push(this.data.task1.statusId)
        if (this.data.task2)    statuses.push(this.data.task2.statusId)
        if (this.data.project1) statuses.push(this.data.project1.statusId)
        if (this.data.project2) statuses.push(this.data.project2.statusId)

        let sessionLoader = new SessionLoader();

        sessionLoader.process(gd.session.findMissing({
            statuses: _.uniq(statuses),
        }));

        sessionLoader.done(()=>{
            this.sendBusEvents()
        });
    }

    sendBusEvents() {
        let predecessor, successor, predecessorType, successorType;

        /** ------------ DETERMINE PREDECESSOR AND SUCCESSOR OBJECT TYPES ------------ **/
        if (this.data.task1Id)          predecessorType = 'task'
        else if (this.data.project1Id)  predecessorType = 'project'
        else if (this.data.event1Id)    predecessorType = 'event'

        if (this.data.task2Id)          successorType = 'task'
        else if (this.data.project2Id)  successorType = 'project'
        else if (this.data.event2Id)    successorType = 'event'

        /** ------------ PREPARE SUCCESSOR AND PREDECESSOR OBJECTS ------------ **/
        switch (predecessorType) {
            case 'task'     : predecessor = _.assign({}, this.data.task1, {taskId: this.data.task1Id}); break;
            case 'project'  : predecessor = _.assign({}, this.data.project1, {projectId: this.data.project1Id}); break;
            case 'event'    : predecessor = _.assign({}, this.data.event1, {eventId: this.data.event1Id}); break;
        }

        switch (successorType) {
            case 'task'     : successor = _.assign({}, this.data.task2, {taskId: this.data.task2Id}); break;
            case 'project'  : successor = _.assign({}, this.data.project2, {projectId: this.data.project2Id}); break;
            case 'event'    : successor = _.assign({}, this.data.event2, {eventId: this.data.event2Id}); break;
        }

        /** ------------ DISPATCH MODEL BUS EVENTS ------------ **/
        switch (predecessorType) {
            case 'task'     : gd.modelBus.newUpdate('task-dependency', this.method, this.data.task1Id, {successor}, {task: {id: this.data.task1Id}, isBulkUpdate: true}); break;
            case 'project'  : gd.modelBus.newUpdate('project-dependency', this.method, this.data.project1Id, {successor}, {project: {id: this.data.project1Id}, isBulkUpdate: true}); break;
            case 'event'    : gd.modelBus.newUpdate('event-dependency', this.method, this.data.event1Id, {successor}, {event: {id: this.data.event1Id}, isBulkUpdate: true}); break;
        }

        switch (successorType) {
            case 'task'     : gd.modelBus.newUpdate('task-dependency', this.method, this.data.task2Id, {predecessor}, {task: {id: this.data.task2Id}, isBulkUpdate: true}); break;
            case 'project'  : gd.modelBus.newUpdate('project-dependency', this.method, this.data.project2Id, {predecessor}, {project: {id: this.data.project2Id}, isBulkUpdate: true}); break;
            case 'event'    : gd.modelBus.newUpdate('event-dependency', this.method, this.data.event2Id, {predecessor}, {event: {id: this.data.event2Id}, isBulkUpdate: true}); break;
        }

        gd.modelBus.newUpdate('dependency', this.method, this.data.id, this.data, _.assign({}, this.header, {dependencyId: this.data.id}));
    }
};
